import styled from "styled-components";
// import Theme from "../../Styles/Themes";
// import config from "../../Config/config.json"

export const Container = styled.select`
    display: flex;
    border-radius: 10px;
    background: #fff;
    padding: 5.313px 6.816px 5.73px 7.129px;
    justify-content: center;
    align-items: center;
    color: #006560;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    cursor: pointer;
    outline: none;
    border: none;
    @media (min-width: 720px) {
        background: #006560;
        padding: 20px 25px;
        justify-content: center;
        align-items: center;
        color: #FFF;
        font-size: 20px;
    }
    @media (min-width: 1281px) {
        font-size: 32px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: flex;
        border-radius: 10px;
        background: #fff;
        padding: 5.313px 6.816px 5.73px 7.129px;
        justify-content: center;
        align-items: center;
        color: #006560;
        font-size: 18px;
    }
`;

export const StyledOption = styled.option`
    justify-content: center;
    align-items: center;
    color: #006560;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    @media (min-width: 720px) {
        color: #fff;
        font-weight: 600; 
        text-align: start;
        line-height: 0;
    }
    @media (min-width: 1281px) {
        font-size: 18px;
    }
`;